import { SalesRepresentativeStore } from 'src/models/store/user/sales';
import { LeadsStore } from '../models/store/leads/leadsStore';
import { CmsStore } from '../models/store/cms/cmsStore';
import { InventoryStore } from '../models/store/inventory/inventoryStore';
import { reducer as cmsReducer } from './cms.reducer';
import { reducer as inventoryReducer } from './inventory.reducer';
import { reducer as leadsReducer } from './leads.reducer';
import { reducer as salesReducer } from './user/sales.reducer';
import { reducer as patientReducer } from './user/patient.reducer';
import { reducer as doctorReducer } from './user/doctor.reducer';
import { reducer as vlesReducer } from './user/vle.reducer';
import { reducer as diagnosticsReducer } from './user/diagnostic.reducer';
import { reducer as hospitalReducer } from './user/hospital.reducer';
import { reducer as pharmacyReducer } from './user/pharmacy.reducer';
import { reducer as bloodBankReducer } from './user/blood-bank.reducer';
import { reducer as ambulanceReducer } from './user/ambulance.reducer';
import { reducer as interestFormReducer } from './interestForm.reducer';
import { reducer as subscriptionPlansReducer } from './subscription/subscription-plans.reducer';
import { reducer as subscriptionsReducer } from './subscription/subscriptions.reducer';
import { PatientStore } from 'src/models/store/user/patient';
import { VleStore } from 'src/models/store/user/vle';
import { SubscriptionPlansStore } from 'src/models/store/subscription/subscriptionPlansStore';
import { SubscriptionsStore } from 'src/models/store/subscription/subscriptionsStore';

export interface State {
  cms: CmsStore;
  leads: LeadsStore;
  inventory: InventoryStore;
  salesRepresentatives: SalesRepresentativeStore;
  patients: PatientStore;
  vles: VleStore;
  doctors: any;
  diagnostics: any;
  hospitals: any;
  pharmacies: any;
  ambulances: any;
  bloodBanks: any;
  interestForm: any;
  subscriptionPlans: SubscriptionPlansStore;
  subscriptions: SubscriptionsStore;
}

export const reducers = {
  cms: cmsReducer,
  leads: leadsReducer,
  inventory: inventoryReducer,
  salesRepresentatives: salesReducer,
  patients: patientReducer,
  vles: vlesReducer,
  doctors: doctorReducer,
  diagnostics: diagnosticsReducer,
  hospitals: hospitalReducer,
  pharmacies: pharmacyReducer,
  ambulances: ambulanceReducer,
  bloodBanks: bloodBankReducer,
  interestForm: interestFormReducer,
  subscriptionPlans: subscriptionPlansReducer,
  subscriptions: subscriptionsReducer,
};
